import { Card, CardContent, Typography } from "@mui/material";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./comentarios.scss";

export default function ComentariosClientes({ breakpoint, pagination, style }) {
  const isDesktop = window.innerWidth > 1000;
  const isTablet = window.innerWidth > 600;

  return (
    <Swiper
      spaceBetween={50}
      navigation={isTablet || isDesktop ? true : false}
      modules={[Navigation, Pagination]}
      breakpoints={breakpoint}
      pagination={pagination}
    >
      <SwiperSlide key={1} className="swiper-slide">
        <Card
          className="card-comentario"
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "lightblue",
              padding: "20px",
            },
          }}>
          <CardContent>
            <Typography className="texto">
              Foi uma ótima experiência! Pela agilidade e competência, com
              certeza, eu recomendaria os serviços.
            </Typography>
          </CardContent>
        </Card>
      </SwiperSlide>
      <SwiperSlide key={2} className="swiper-slide">
        <Card
          className="card-comentario"
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "lightblue",
              padding: "20px",
            },
          }}>
          <CardContent>
            <Typography className="texto">
              Recomendo muito! É confiável, e o atendimento é excelente.
              Sempre que precisei de suporte, minhas dúvidas foram sanadas e
              resolvidas rapidamente. Recomendo também pela facilidade no
              pagamento.
            </Typography>
          </CardContent>
        </Card>
      </SwiperSlide>
      <SwiperSlide key={2} className="swiper-slide">
        <Card
          className="card-comentario"
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "lightblue",
              padding: "20px",
            },
          }}>
          <CardContent>
            <Typography className="texto">
              O atendimento é rápido e claro. 100% das vezes meus pedidos
              foram resolvidos.
            </Typography>
          </CardContent>
        </Card>
      </SwiperSlide>
      <SwiperSlide key={3} className="swiper-slide">
        <Card
          className="card-comentario"
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "lightblue",
              padding: "20px",
            },
          }}>
          <CardContent>
            <Typography className="texto">
              Achei a experiência ótima! Tudo foi rápido e objetivo,
              cumprindo perfeitamente a função a que o serviço se propõe.
            </Typography>
          </CardContent>
        </Card>
      </SwiperSlide>
    </Swiper>
  )
}
